<template>
  <div>
    <!-- <h5 class="info-text">
      Let's start with the basic information (with validation)
    </h5> -->
    <div class="row justify-content-center mt-5">
      <div class="row">
        <base-input
          name="ctps"
          class="col-sm-4"
          required
          placeholder="CTPS"
          v-model="model.ctps"
          v-validate="modelValidations.ctps"
          :error="getError('ctps')"
        >
        </base-input>
        <base-input
          name="serie"
          class="col-sm-4"
          required
          placeholder="Série"
          v-model="model.serie"
          v-validate="modelValidations.serie"
          :error="getError('serie')"
        >
        </base-input>
        <base-input
          name="dateExpedicaoCtps"
          class="col-sm-4"
          type="tel"
          v-mask="'##/##/####'"
          required
          placeholder="Data Expedição"
          v-model="model.dateExpedicaoCtps"
          v-validate="modelValidations.dateExpedicaoCtps"
          :error="getError('dateExpedicaoCtps')"
        >
        </base-input>
      </div>


      <div class="row">
        <base-input
          name="ci"
          class="col-sm-4"
          required
          placeholder="CI"
          v-model="model.ci"
          v-validate="modelValidations.ci"
          :error="getError('ci')"
        >
        </base-input>
        <base-input
          name="orgaoExpeditor"
          class="col-sm-4"
          required
          placeholder="Orgão Expeditor"
          v-model="model.orgaoExpeditor"
          v-validate="modelValidations.orgaoExpeditor"
          :error="getError('orgaoExpeditor')"
        >
        </base-input>
        <base-input
          name="dateExpedicaoCi"
          class="col-sm-4"
          required
          type="tel"
          v-mask="'##/##/####'"
          placeholder="Data Expedição"
          v-model="model.dateExpedicaoCi"
          v-validate="modelValidations.dateExpedicaoCi"
          :error="getError('dateExpedicaoCi')"
        >
        </base-input>
      </div>


      <div class="row">
        <base-input
          name="cpf"
          v-if="this.$route.params.typeCad == 1"
          class="col-sm-3"
          type="tel"
          v-mask="'###.###.###-##'"
          required
          placeholder="CPF"
          v-model="cpf"
          v-validate="modelValidations.cpf"
          :error="getError('cpf')"
        >
        </base-input>
        <base-input
          name="cpf"
          v-else
          class="col-sm-3"
          type="tel"
          v-mask="'###.###.###-##'"
          required
          placeholder="CPF"
          v-model="cpf"
          v-validate="modelValidations.cpf"
          :error="getError('cpf')"
          
          disabled
        >
        </base-input>
        <base-input
          name="tituloEleitor"
          class="col-sm-3"
          required
          placeholder="Título de Eleitor"
          v-model="model.tituloEleitor"
          v-validate="modelValidations.tituloEleitor"
          :error="getError('tituloEleitor')"
        >
        </base-input>
        <base-input
          name="zona"
          class="col-sm-3"
          required
          placeholder="Zona"
          v-model="model.zona"
          v-validate="modelValidations.zona"
          :error="getError('zona')"
        >
        </base-input>
        <base-input
          name="secao"
          class="col-sm-3"
          required
          placeholder="Seção"
          v-model="model.secao"
          v-validate="modelValidations.secao"
          :error="getError('secao')"
        >
        </base-input>
      </div>


      <div class="row">
        <base-input
          name="certificadoReservista"
          class="col-sm-6"
          required
          placeholder="Certificado de Reservista"
          v-model="model.certificadoReservista"
          v-validate="modelValidations.certificadoReservista"
          :error="getError('certificadoReservista')"
        >
        </base-input>
        <base-input
          name="categoria"
          class="col-sm-6"
          required
          placeholder="Categoria"
          v-model="model.categoria"
          v-validate="modelValidations.categoria"
          :error="getError('categoria')"
        >
        </base-input>
        <!-- <base-input
          name="serie"
          class="col-sm-4"
          required
          placeholder="Série"
          v-model="model.serie"
          v-validate="modelValidations.serie"
          :error="getError('serie')"
        >
        </base-input> -->
      </div>


      <div class="row">
        <base-input
          name="pisPasep"
          class="col-sm-6"
          required
          placeholder="Pis/Pasep"
          v-model="model.pisPasep"
          v-validate="modelValidations.pisPasep"
          :error="getError('pisPasep')"
        >
        </base-input>
        <base-input
          name="dataPisPasep"
          class="col-sm-6"
          type="tel"
          v-mask="'##/##/####'"
          required
          placeholder="Data Pis/Pasep"
          v-model="model.dataPisPasep"
          v-validate="modelValidations.dataPisPasep"
          :error="getError('dataPisPasep')"
        >
        </base-input>
      </div>


      <div class="row">
        <!-- <base-input
          name="habiltProfiss"
          class="col-sm-4"
          required
          placeholder="Habilt. Profiss."
          v-model="model.habiltProfiss"
          v-validate="modelValidations.habiltProfiss"
          :error="getError('habiltProfiss')"
        >
        </base-input> -->
        <!-- <base-input
          name="registroProf"
          class="col-sm-6"
          required
          placeholder="Registro Profiss."
          v-model="model.registroProf"
          v-validate="modelValidations.registroProf"
          :error="getError('registroProf')"
        >
        </base-input> -->
        <!-- <base-input
          name="orgaoRegistro"
          class="col-sm-6"
          required
          placeholder="Orgão do Registro"
          v-model="model.orgaoRegistro"
          v-validate="modelValidations.orgaoRegistro"
          :error="getError('orgaoRegistro')"
        >
        </base-input> -->
      </div>


      


    </div>
  </div>
</template>
<script>
import { BaseInput } from "@/components";
import swal from "sweetalert2";

export default {
  name: "documentacao",
  components: {
    BaseInput
  },

  props: {
    dadosFuncionario: {
      type: Object,
      default: {}
    }
  },

  data() {
    return {
      cpf: "",
      model: {
        ctps: "",
        serie: "",
        dateExpedicaoCtps: "",
        ci: "",
        orgaoExpeditor: "",
        dateExpedicaoCi: "",
        cpf: "",
        tituloEleitor: "",
        zona: "",
        secao: "",
        certificadoReservista: "",
        categoria: "",
        serie: "",
        pisPasep: "",
        dataPisPasep: "",
        habiltProfiss: "",
        registroProf: "",
        orgaoRegistro: ""
      },
      modelValidations: {
        ctps: {
          required: false,
          numeric: true
        },
        serie: {
          required: false,
          numeric: true
        },
        dateExpedicaoCtps: {
          required: false,
          min: 10
        },
        ci: {
          required: false,
          numeric: true
        },
        orgaoExpeditor: {
          required: false,
          min: 2
        },
        dateExpedicaoCi: {
          required: false,
        },
        cpf: {
          required: true,
          min: 11
        },
        tituloEleitor: {
          required: false,
          numeric: true,
        },
        zona: {
          required: false,
          numeric: true,
        },
        secao: {
          required: false,
          numeric: true,
        },
        certificadoReservista: {
          required: false,
          numeric: true,
        },
        categoria: {
          required: false,
          numeric: true,
        },
        serie: {
          required: false,
          numeric: true,
        },
        pisPasep: {
          required: true,
          numeric: true,
        },
        dataPisPasep: {
          required: false,
          min: 10
        },
        habiltProfiss: {
          required: false,
          numeric: false,
        },
        registroProf: {
          required: false,
          numeric: true,
        },
        orgaoRegistro: {
          required: false,
          numeric: false,
        }
       
      }
    };
  },

  mounted(){
    this.$root.$on('recuperarDocumentacao', () => {
      this.$root.$emit('returnCadastrarFuncionarioDocumentacao', this.model)
    });

    /* this.$root.$on('pegarCpf', () => {
      this.$root.$emit('retornarCpf', this.model.cpf)
    }); */

    if(this.dadosFuncionario){
      this.model.ctps = this.dadosFuncionario.ctps
      this.model.serie = this.dadosFuncionario.ctps_serie
      this.model.dateExpedicaoCtps = this.dadosFuncionario.expedicao
      this.model.ci = this.dadosFuncionario.rg
      this.model.orgaoExpeditor = this.dadosFuncionario.orgao_expeditor
      this.model.dateExpedicaoCi = this.dadosFuncionario.data_expedicao
      this.cpf = this.dadosFuncionario.cpf
      this.model.tituloEleitor = this.dadosFuncionario.titulo_numero
      this.model.zona = this.dadosFuncionario.titulo_zona
      this.model.secao = this.dadosFuncionario.titulo_secao
      this.model.certificadoReservista = this.dadosFuncionario.cert_reservista_ra
      this.model.categoria = this.dadosFuncionario.certificado_reservista_categoria
      this.model.pisPasep = this.dadosFuncionario.numero_pis
      this.model.dataPisPasep = this.dadosFuncionario.data_pis
      // this.model.habiltProfiss = this.dadosFuncionario.nome
      // this.model.registroProf = this.dadosFuncionario.data_nascimento
      // this.model.orgaoRegistro = this.dadosFuncionario.pai
    }
  },

  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll().then(res => {
        this.$emit("on-validated", res, this.model);
        return res;
      });
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    verificarCpf(cpf){
      let th = this
      this.isLoading = true

      let bodyFormData = {
        setDB: this.$cookies.get('db'),
        cnpj: this.$cookies.get('cnpj'),
        cpf: cpf
      }

      this.axios.post('/api/empregado/verificarCpfEmpregado', bodyFormData)
      .then((response) => {
        th.isLoading = false

        if(response.data.data.dados[0].PODE_CADASTRAR == "S"){
          th.model.cpf = cpf
        }else{
          th.showSwal('auto-close', 'Erro', 'Este CPF já possui cadastro!', 'error')
          th.cpf = ""
        }
        
      })
      .catch((err) => {
        th.isLoading = false
        th.showSwal('auto-close', 'Erro', 'Este CPF já possui cadastro!', 'error')
        th.cpf = ""
      })
    }
  },


  watch: {
    cpf(newVal){
      if(this.$route.params.typeCad == 1){//create
        if(newVal.length == 14){
          this.verificarCpf(newVal.replace(/[. - / - -]/g, ''))
        }
      }else if(this.$route.params.typeCad == 2){}//update
      
            
    }
  }
};
</script>
<style></style>
